import type { FunctionComponent } from 'react';
import { StyleAerialImageComponent } from '../../MediaShowcaseBrick.styled';

interface AerialShowcaseImage {
  href: string;
  alt: string;
}

export const AerialShowcaseImage: FunctionComponent<AerialShowcaseImage> = ({ href, alt }) => {
  return <StyleAerialImageComponent src={href} alt={alt} />;
};
